module.exports = __webpack_public_path__ + "img/map.0a06f836.png";